import { useIntl } from 'react-intl';
import { Divider } from 'antd';

const FmFunnels = (data) => {
  const intl = useIntl();
  const {
    minimum_predicted_deliveries_count,
    maximum_predicted_deliveries_count,
    overall_picked_up_count,
    mega_red_businesses_collected_deliveries_count
  } = data.data || {};
  const minPredicted = minimum_predicted_deliveries_count || 0;
  const maxPredicted = maximum_predicted_deliveries_count || 0;
  const avgPredicted = (minPredicted + maxPredicted) / 2;
  const pickedUpDeliveries =
    (overall_picked_up_count || 0) +
      mega_red_businesses_collected_deliveries_count || 0;

  const headingToHubs = data?.data?.completed_deliveries_count || 0;
  const overallReceived = data?.data?.overall_received_count;
  return (
    <div className="br-overview__funnel-wrapper">
      <span className="heading">
        {intl.formatMessage({ id: 'ops_control.overview.funnels.title' })}
      </span>
      <Divider />
      <div className="br-overview__funnel-chart">
        <div className="br-overview__funnel-row">
          <span className="label_sm">
            {intl.formatMessage({
              id: 'ops_control.overview.funnels.predicted'
            })}
          </span>
          <div className="br-overview__trapzoid1 trapzoid"></div>
          <span className="label_sm">{Math.ceil(avgPredicted)}</span>
        </div>
        <div className="br-overview__funnel-row">
          <span className="label_sm">
            {intl.formatMessage({
              id: 'ops_control.overview.funnels.picked'
            })}
          </span>
          <div className="br-overview__trapzoid2 trapzoid">
            <p className="label_sm">{'100%'}</p>
          </div>
          <span>{pickedUpDeliveries}</span>
        </div>
        <div className="br-overview__funnel-row">
          <span className="label_sm">
            {intl.formatMessage({
              id: 'ops_control.overview.funnels.received_in_sf'
            })}
          </span>
          <div className="br-overview__trapzoid3 trapzoid">
            <p className="label_sm">
              {' '}
              {overallReceived != null && pickedUpDeliveries > 0
                ? `${((overallReceived / pickedUpDeliveries) * 100).toFixed(
                    0
                  )}%`
                : '0%'}
            </p>
          </div>
          <span className="label_sm">{overallReceived}</span>
        </div>
        <div className="br-overview__funnel-row">
          <span className="label_sm">
            {intl.formatMessage({
              id: 'ops_control.overview.funnels.received_in_hub'
            })}
          </span>
          <div className="br-overview__triangle-wrapper">
            <div className="br-overview__trapzoid4"></div>
            <p className="br-overview-triangle-percentage caption-medium">
              {headingToHubs != null && pickedUpDeliveries > 0
                ? `${((headingToHubs / pickedUpDeliveries) * 100).toFixed(0)}%`
                : '0%'}
            </p>
          </div>
          <span className="label_sm">{headingToHubs}</span>
        </div>
      </div>
    </div>
  );
};
export default FmFunnels;
